import { makeStyles } from "@material-ui/styles";

export default makeStyles((theme: any) => ({
  width100: {
    width: "100%",
  },
}));
